import { mintIdempotencyKey } from '@croissants/ui';
import { readString, removeKey, writeString } from './storage';

/**
 * Idempotency keys for the mutations that move money (PRD PAY-006, NFR-003).
 *
 * The key has to survive the retry, which means it has to survive the thing that
 * caused it: a dropped 4G connection, a backgrounded tab, a guest tapping "Pay"
 * twice. So it is minted once per logical attempt and persisted, not generated at
 * the call site - a fresh key per call would make every retry a second order.
 *
 * The key is dropped only when the attempt has definitively succeeded, at which
 * point a later action is genuinely a new attempt.
 */

const PREFIX = 'cib.idem.';

// The one mint (packages/ui, F5): a uuid, or time plus entropy on a runtime
// without crypto.randomUUID - never a thrown error at the moment of a payment.
const mint = (): string => mintIdempotencyKey('g');

/** The stable key for a logical attempt, minting one on first use. */
export function idempotencyKeyFor(scope: string): string {
  const storageKey = `${PREFIX}${scope}`;
  const existing = readString(storageKey);
  if (existing !== null && existing.length >= 8) return existing;
  const fresh = mint();
  writeString(storageKey, fresh);
  return fresh;
}

/** Called after a definitive success, so the next action is a new attempt. */
export function clearIdempotencyKey(scope: string): void {
  removeKey(`${PREFIX}${scope}`);
}
